import React from 'react';
import { Collapse } from 'react-bootstrap';
import CareMapprButton from '../../../../../components/Button/CareMapprButton';
import Select from 'react-select';
import { useForm } from 'react-hook-form';

const AddOrderSet = ({
  open,
  onClose,
  orderSetData,
  onAddOrderSetToSection,
}) => {
  const { register, getValues, watch, setValue, reset } = useForm({
    defaultValues: {
      selectedOrderSetId: '',
    },
  });

  const selectedOrderSetIdValue = watch('selectedOrderSetId');

  const orderSetOptions = orderSetData.map((orderSet) => {
    return {
      value: orderSet.id,
      label: orderSet.orderSetName,
    };
  });

  return (
    <Collapse in={open}>
      <div>
        <div className="d-flex align-items-center px-2 gap-2">
          <div className="add-order-set-label">Name of Order set</div>
          <Select
            className="add-order-set-select"
            onChange={(selectedOptions) => {
              const selectedOrderSetIdValue = selectedOptions.value;
              setValue('selectedOrderSetId', selectedOrderSetIdValue, {
                shouldDirty: true,
                shouldValidate: true,
              });
            }}
            value={
              orderSetOptions.find(
                (opt) => opt.value === selectedOrderSetIdValue,
              ) || ''
            }
            options={orderSetOptions}
            placeholder="Search order set ..."
          />
        </div>
        <div className="d-flex align-items-center gap-2">
          <CareMapprButton
            label="Cancel & close"
            variant="transparent"
            onClick={onClose}
            labelClassName="medication-cancel-button"
          />
          <CareMapprButton
            label="Save"
            onClick={() => {
              const formValues = getValues();
              onAddOrderSetToSection(formValues);
            }}
          />
        </div>
      </div>
    </Collapse>
  );
};

export default AddOrderSet;
